import { render, staticRenderFns } from "./StaffSkillList.vue?vue&type=template&id=703d8f30&scoped=true&"
import script from "./StaffSkillList.vue?vue&type=script&lang=js&"
export * from "./StaffSkillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d8f30",
  null
  
)

export default component.exports